import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import "./Team.css";

// Import local images
import img1 from "../../assets/Team/Benny.png";
import img2 from "../../assets/Team/Bharani.png";
import img3 from "../../assets/Team/Areevu.png";
import img4 from "../../assets/Team/Shabeer.png";
import img5 from "../../assets/Team/Arun.png";
import img6 from "../../assets/Team/Ramji.png";
import img7 from "../../assets/Team/Dinesh.png";
import img8 from "../../assets/Team/Vignesh.png";
import img9 from "../../assets/Team/Neelavathi.png";
import img10 from "../../assets/Team/Divakar.png";
import img11 from "../../assets/Team/Hari.png";
/* import img12 from "../../assets/Team/Akshaya.png";
 */
const teamMembers = [
    { name: "Benny Abraham R", role: "CEO", img: img1 },
    { name: "Bharanitharan M", role: "Production Head", img: img2 },
    { name: "Arevazhagun V C", role: "Digital Head", img: img3 },
    { name: "Mohammad Shabeer Khan S", role: "Creative Head", img: img4 },
    { name: "Arun Raj B", role: "Marketing Head", img: img5 },
    { name: "Ramji B", role: "Project Manager", img: img6 },
    { name: "Dinesh Kumar S", role: "Senior Graphic Designer", img: img7 },
    { name: "Vignesh R", role: "Video Editor", img: img8 },
    { name: "Neelavathi S", role: "UI/UX & Graphic Designer", img: img9 },
    { name: "Diwakar S", role: "UI/UX Designer", img: img10 },
    { name: "Hariharan S", role: "Web Developer", img: img11 },
/*     { name: "Akhshaya M", role: "Social Media Executive", img: img12 },
 */];

const TeamGrid = () => {
    return (
        <section className="team-grid-section">
            <Container>
                <div className="section-header1 text-center mb-5">
                    <div className="d-flex justify-content-center">
                        <span className="badge-team">THE ASCENT TEAM</span>
                    </div>
                    <h2 className="section-title mt-4">Meet the Minds Behind Ascent</h2>
                    <p className="section-subtitle mx-auto mt-3">
                        Our team brings together strategy, creativity, and technology to build brands that stand out.
                        Each member contributes unique expertise to deliver meaningful and impactful solutions.
                    </p>
                </div>

                <Row className="gy-5 justify-content-center">
                    {teamMembers.map((member, index) => (
                        <Col key={index} lg={4} md={6} sm={12}>
                            <motion.div
                                className="team-card"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: (index % 3) * 0.1, duration: 0.6 }}
                                viewport={{ once: true }}
                            >
                                <div className="team-img-wrapper">
                                    <img
                                        src={member.img}
                                        alt={member.name}
                                        className="team-img grayscale"
                                    />
                                    {/* Colored line matching design */}
                                    <div className="card-accent-line"></div>
                                </div>
                                <div className="team-member-info">
                                    <h4 className="member-name">{member.name}</h4>
                                    <p className="member-role">{member.role}</p>
                                </div>
                            </motion.div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default TeamGrid;
